<template>
  <div>
    <!-- Header info -->
    <div class="lc-taxas-header" v-if="rendered">
      <div class="lc-taxas-header__icon">
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <line x1="12" y1="1" x2="12" y2="23" />
          <path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" />
        </svg>
      </div>
      <div>
        <h2 class="lc-taxas-header__title">Taxas de Juro Website</h2>
        <p class="lc-taxas-header__sub">
          Atualize as taxas que são apresentadas no website da Reorganiza.
        </p>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="!rendered" class="lc-loading">
      <div class="lc-loading__spinner"></div>
      <p>A carregar taxas...</p>
    </div>

    <!-- Taxa Cards -->
    <div class="lc-taxas-grid" v-if="rendered">
      <div
        class="lc-taxa-card"
        v-for="row in dataTable"
        :key="row.id"
        :class="{ 'lc-taxa-card--saved': savedId === row.id }"
      >
        <div class="lc-taxa-card__header">
          <div
            class="lc-taxa-card__icon"
            :style="{ background: produtoGradient(row.produto) }"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <rect x="2" y="3" width="20" height="14" rx="2" />
              <line x1="8" y1="21" x2="16" y2="21" />
              <line x1="12" y1="17" x2="12" y2="21" />
            </svg>
          </div>
          <div>
            <div class="lc-taxa-card__produto">
              {{ formatProduto(row.produto) }}
            </div>
            <div class="lc-taxa-card__label">Taxa de Juro Indicativa</div>
          </div>
        </div>

        <div class="lc-taxa-card__body">
          <div class="lc-taxa-input-wrap">
            <input
              class="lc-taxa-input"
              type="text"
              v-model="row.taxa"
              placeholder="Ex: 3.5"
              @keyup.enter="guardar(row)"
            />
            <span class="lc-taxa-input__suffix">%</span>
          </div>
        </div>

        <div class="lc-taxa-card__footer">
          <button
            class="lc-taxa-btn"
            @click="guardar(row)"
            :class="{
              'lc-taxa-btn--saving': savingId === row.id,
              'lc-taxa-btn--saved': savedId === row.id,
            }"
            :disabled="savingId === row.id"
          >
            <span
              v-if="savingId === row.id"
              class="lc-taxa-btn__spinner"
            ></span>
            <svg
              v-else-if="savedId === row.id"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
            <svg
              v-else
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
            >
              <path
                d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z"
              />
              <polyline points="17 21 17 13 7 13 7 21" />
            </svg>
            {{
              savingId === row.id
                ? "A guardar..."
                : savedId === row.id
                ? "Guardado!"
                : "Guardar"
            }}
          </button>
        </div>
      </div>
    </div>

    <!-- Aviso -->
    <div class="lc-taxa-aviso" v-if="rendered">
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
      As taxas são apresentadas ao público no website. Utilize o formato
      numérico com ponto decimal (ex: 3.5).
    </div>
  </div>
</template>

<script>
  import api from "@/api/index";

  export default {
    data() {
      return {
        rendered: false,
        dataTable: [],
        savingId: null,
        savedId: null,
      };
    },
    methods: {
      formatProduto(p) {
        const map = {
          credito_habitacao: "Crédito Habitação",
          credito_consolidado: "Crédito Consolidado",
          credito_pessoal: "Crédito Pessoal",
        };
        return map[p] || p;
      },
      produtoGradient(p) {
        const map = {
          credito_habitacao: "linear-gradient(135deg,#4eab3e,#a9d42c)",
          credito_consolidado: "linear-gradient(135deg,#2980b9,#6dd5fa)",
          credito_pessoal: "linear-gradient(135deg,#f39c12,#f7c948)",
        };
        return map[p] || "linear-gradient(135deg,#9ca3af,#d1d5db)";
      },
      async inicio() {
        const res = await api.listarTaxas();
        if (res) {
          this.dataTable = res.sort((a, b) => (a.id > b.id ? -1 : 1));
        }
        this.rendered = true;
      },
      async guardar(produto) {
        let taxa = String(produto.taxa).replaceAll(",", ".");
        if (isNaN(taxa) || taxa === "") {
          alert("O número inserido não é válido.");
          return;
        }
        this.savingId = produto.id;
        this.savedId = null;
        const res = await api.atualizarTaxas({
          id: produto.id,
          taxa: parseFloat(taxa),
        });
        this.savingId = null;
        if (res) {
          this.savedId = produto.id;
          setTimeout(() => {
            this.savedId = null;
          }, 2500);
        }
      },
    },
    mounted() {
      this.inicio();
    },
  };
</script>

<style scoped>
  /* Header */
  .lc-taxas-header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 28px;
  }
  .lc-taxas-header__icon {
    width: 52px;
    height: 52px;
    border-radius: 14px;
    background: linear-gradient(135deg, #4eab3e, #a9d42c);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    flex-shrink: 0;
  }
  .lc-taxas-header__title {
    font-size: 20px;
    font-weight: 700;
    color: #111318;
    margin: 0 0 4px;
  }
  .lc-taxas-header__sub {
    font-size: 13px;
    color: #9ca3af;
    margin: 0;
  }

  /* Loading */
  .lc-loading {
    text-align: center;
    padding: 60px;
    color: #9ca3af;
  }
  .lc-loading__spinner {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 3px solid #e5e7eb;
    border-top-color: #4eab3e;
    animation: lc-spin 0.7s linear infinite;
    margin: 0 auto 12px;
  }
  @keyframes lc-spin {
    to {
      transform: rotate(360deg);
    }
  }

  /* Grid */
  .lc-taxas-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-bottom: 20px;
  }
  @media (max-width: 900px) {
    .lc-taxas-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  @media (max-width: 600px) {
    .lc-taxas-grid {
      grid-template-columns: 1fr;
    }
  }

  /* Card */
  .lc-taxa-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 16px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
    overflow: hidden;
    transition: box-shadow 0.2s, transform 0.2s;
  }
  .lc-taxa-card:hover {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.09);
    transform: translateY(-2px);
  }
  .lc-taxa-card--saved {
    border-color: rgba(78, 171, 62, 0.3);
  }

  .lc-taxa-card__header {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 20px 20px 16px;
    border-bottom: 1px solid #f3f4f6;
  }
  .lc-taxa-card__icon {
    width: 44px;
    height: 44px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    flex-shrink: 0;
  }
  .lc-taxa-card__produto {
    font-size: 14px;
    font-weight: 700;
    color: #111318;
  }
  .lc-taxa-card__label {
    font-size: 11px;
    color: #9ca3af;
    margin-top: 2px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .lc-taxa-card__body {
    padding: 20px;
  }

  /* Input */
  .lc-taxa-input-wrap {
    position: relative;
    display: flex;
    align-items: center;
  }
  .lc-taxa-input {
    width: 100%;
    padding: 12px 40px 12px 16px;
    border: 2px solid #e5e7eb;
    border-radius: 10px;
    font-size: 28px;
    font-weight: 700;
    color: #111318;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;
    font-family: "DM Mono", monospace;
    text-align: center;
  }
  .lc-taxa-input:focus {
    border-color: #4eab3e;
    box-shadow: 0 0 0 3px rgba(78, 171, 62, 0.1);
  }
  .lc-taxa-input__suffix {
    position: absolute;
    right: 14px;
    font-size: 20px;
    font-weight: 700;
    color: #9ca3af;
    pointer-events: none;
  }

  .lc-taxa-card__footer {
    padding: 0 20px 20px;
  }

  /* Button */
  .lc-taxa-btn {
    width: 100%;
    padding: 11px;
    background: #111318;
    color: #fff;
    border: none;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
  }
  .lc-taxa-btn:hover:not(:disabled) {
    background: #2d3139;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  .lc-taxa-btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }
  .lc-taxa-btn--saved {
    background: #4eab3e !important;
  }
  .lc-taxa-btn__spinner {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.4);
    border-top-color: #fff;
    animation: lc-spin 0.7s linear infinite;
  }

  /* Aviso */
  .lc-taxa-aviso {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: #9ca3af;
    background: #f8f9fb;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 10px 14px;
  }
</style>
